
import { importSync as i } from '@embroider/macros';
let d = window.define;
